import styled from '@emotion/styled';
import React from 'react';
import { BackgroundLines } from 'src/styles/homePage';

export const PageBackgroundContainer = styled.div`
  background: linear-gradient(180deg, #fff 40%, rgba(231, 239, 255, 1) 100%);
  position: relative;
`;

interface PageBackgroundProps {
  children: React.ReactElement[] | React.ReactElement;
  hideLines: boolean;
}

const PageBackground: React.FC<PageBackgroundProps> = ({ children, hideLines }) => {
  return (
    <PageBackgroundContainer>
      {hideLines ? null : <BackgroundLines />}
      {children}
    </PageBackgroundContainer>
  );
};

export default PageBackground;
